import React from 'react';

import PostLayout from '../../../../Layout/PostLayout';
import FolderShow from './FolderShow';

function Wrapper({ post }: any) {
  return <PostLayout post={post} postMainContent={<FolderShow post={post} />} />;
}

export default Wrapper;
